module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_020.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_020.png
// module id = 2367
// module chunks = 5